import { CheckboxKanbanItem } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useFileStore } from 'src/features/files';
import { useTableStore } from 'src/features/list/store';
import useOnClickOutside from 'use-onclickoutside';

export const PersonFieldCell = ({ task: item, fieldId, data = [], api }: any) => {
  const router = useRouter();
  const currentFile = useFileStore(
    useCallback((s) => s.files[router.query.slug as string], [router.query.slug as string])
  );
  const [assigneeOptions, setAssigneeOptions] = useState<any>([]);
  const { onUpdateCustomFieldData } = useTableStore((s) => ({
    onUpdateCustomFieldData: s.onUpdateCustomFieldData,
  }));
  const myRef = useRef(null);
  const { isReadOnly } = useTableStore();

  useEffect(() => {
    const assignees = currentFile?.membersWithAccess?.map((obj) => ({
      firstname: obj.firstname,
      memberId: obj.memberId,
      avatar: obj.avatar,
      checked: data ? data?.some((assigneeObj) => assigneeObj.memberId === obj.memberId) : false,
    }));
    setAssigneeOptions(assignees);
  }, [currentFile?.membersWithAccess]);

  const handleAssignee = (value, obj) => {
    const assigneeItem = [...data];
    const assignee = data ? data?.map((assigneeObj) => assigneeObj.memberId) : [];
    const index = assignee.indexOf(value);
    const checkboxIndex = assigneeOptions.map((assigneeObj) => assigneeObj.memberId).indexOf(value);
    if (index > -1) {
      assigneeItem.splice(index, 1);
    } else {
      assigneeItem.push(obj);
    }
    if (item?.id) {
      onUpdateCustomFieldData(item, fieldId, assigneeItem);
    }

    const newAsigneeOptions = [...assigneeOptions];

    assigneeOptions[checkboxIndex].checked = !assigneeOptions[checkboxIndex].checked;
    setAssigneeOptions(newAsigneeOptions);
  };

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  if (!item) return <></>;
  if (isReadOnly) return <></>;
  return (
    <div className="bg-white p-6 flex flex-col gap-0 justify-center cursor-pointer" ref={myRef}>
      {assigneeOptions.map((assignee) => {
        return (
          <div
            key={assignee.memberId}
            className="flex gap-8 px-10 h-40 items-center hover:bg-gray-100 min-w-200"
            onClick={handleAssignee.bind(null, assignee.memberId, assignee)}
          >
            <CheckboxKanbanItem
              onChange={handleAssignee.bind(null, assignee.memberId, assignee)}
              checked={assignee.checked}
              size="small"
              color="#33CC48"
            />
            <img
              src={assignee.avatar}
              alt={assignee.firstname}
              className="h-20 w-20 rounded-full object-cover"
              style={{ border: '1px solid #D5D7DD' }}
            />
            <p className="text-sm font-regular text-gray-999 leading-20">{assignee.firstname}</p>
          </div>
        );
      })}
    </div>
  );
};
